import { Menu, Stack, styled } from '@mui/material';

import { colors } from '@/theme/variables';

export const CareLinkRoot = styled(Stack)(() => ({
  position: 'fixed',
  bottom: 120,
  right: 20,

  '& .btn-circle': {
    width: '46px',
    height: '46px',
    borderRadius: '23px',
    transition: 'all .3s',
  },
  '& svg': {
    width: '24px',
    height: '24px',
  },
  '& svg path': {
    fill: colors.white,
    stroke: colors.white,
    strokeWidth: '0',
  },
  '& [aria-expanded="true"]': {
    borderRadius: '0px 23px 23px 23px',

    '& svg': {
      animation: 'bounceUp .3s linear 2',
    },
  },
  '@keyframes bounceUp': {
    '0%': { transform: 'translateY(-10px)' },
    '40%': { transform: 'translateY(-30px)' },
    '60%': { transform: 'translateY(-15px)' },
  },
}));

export const CareLinkMenuRoot = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    transform: 'translateY(-50px)!important',
    backgroundImage: 'none',
    backgroundColor: theme.palette.background.paper,
  },
}));
